import React, { FC } from 'react';
import '../styles/App.scss';

interface ButtonProps {
    onClick?: () => void;
}

const Button: FC<ButtonProps> = (
    {
        onClick,
        children
    }) => {
    return (
        <div className='btn_block'>
            <button type='button' className='btn to-form' onClick={onClick}>{children}</button>
        </div>
    );
};

export default Button;
